import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DefaultLayoutComponent } from './containers/default-layout/default-layout.component';
import { AuthGuard } from './guards/auth.guard';
import { CallbackComponent } from './components/callback/callback.component';

import { adminroutes } from './components/admin/admin-routing.module';
import { myzoneroutes } from './components/my-zone/my-zone-routing.module';
import { renaultzoneroutes } from './components/renault-zone/renault-zone-routing.module';
import { campaignroutes } from './components/campaign-crm/campaign-crm-routing.module';
import { LocalCampaignViewerComponent } from './components/public/local-campaign-viewer/local-campaign-viewer.component';
import { ConditionsAcceptComponent } from './components/conditions-accept/conditions-accept.component';
import { CheckUserR1Component } from './components/check-user-R1/check-user-R1.component';
import { LoginJwtComponent } from './components/login-jwt/login-jwt.component';
import { CampaignCrmViewerComponent } from './components/public/campaign-crm-viewer/campaign-crm-viewer.component';
import { PapLocalCampaignViewerComponent } from './components/public/pap-local-campaign-viewer/pap-local-campaign-viewer.component';
import { CheckUserR2OkComponent } from './components/check-user-R2-ok/check-user-R2-ok.component';
import { LeadApprovedComponent } from './components/public/lead-approved/lead-approved.component';



const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'callback',
    component: CallbackComponent
  },
  {
    path: 'conditions-accept',
    component: ConditionsAcceptComponent
  },
  {
    path: 'check-user-R1',
    component: CheckUserR1Component 
  },
  {
    path: 'check-user-R2-ok',
    component: CheckUserR2OkComponent
  },
  {
    path: 'local-campaign-viewer/:id',
    component: LocalCampaignViewerComponent
  },
  {
    path: 'campaign-crm-viewer/:id',
    component: CampaignCrmViewerComponent
  },
   {
    path: 'pap-local-campaign-viewer/:id',
    component: PapLocalCampaignViewerComponent
  },
  {
    path: 'lead-approved',
    component: LeadApprovedComponent
  },
  {
    path: 'login',
    component: LoginJwtComponent
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    children: [
      { path: 'home', loadChildren: () => import('./components/home/home.module').then(m => m.HomeModule), data: { animation: 'home' }, canActivate: [AuthGuard] },
      { path: 'animation', loadChildren: () => import('./components/animation/animation.module').then(m => m.AnimationModule), data: { animation: 'animation', roles: 'Administrador,RedJefeTaller,RedAsesor,ResponsablePv' }, canActivate: [AuthGuard] },
      { path: 'online-payments', loadChildren: () => import('./components/online-payments/online-payments.module').then(m => m.OnlinePaymentsModule), data: { animation: 'animation', roles: 'Administrador,AdminRenault,RgManagerRed,RgMarketing,RgManagerRecsa,RgTransversal,ResponsablePv,RedJefeTaller,RedAsesor,RedRespMktg,RedPagoOnline' }, canActivate: [AuthGuard] },
      { path: 'dsp', loadChildren: () => import('./components/dsp/dsp.module').then(m => m.DspModule), data: { animation: 'animation', roles: 'Administrador,AdminRenault,RgManagerRed,RgMarketing,RgManagerRecsa,RgTransversal,ResponsablePv,RedJefeTaller,ResponsableCalidad,RedAsesor,RedRespMktg,RedPagoOnline' }, canActivate: [AuthGuard] },
      { path: 'animation-dsp-key-users', loadChildren: () => import('./components/animation-dsp-key-users/animation-dsp-key-users.module').then(m => m.AnimationDspKeyUsersModule), data: { animation: 'animation', roles: 'Administrador,RedJefeTaller,RedAsesor,ResponsablePv' }, canActivate: [AuthGuard] },
      { path: 'dsp-campaign', loadChildren: () => import('./components/dsp-campaign/dsp-campaign.module').then(m => m.DspCampaignModule), data: { animation: 'animation', roles: 'Administrador,AdminRenault,RgManagerRed,RgMarketing,RgManagerRecsa,RgTransversal,ResponsablePv,RedJefeTaller,RedAsesor,RedRespMktg,RedPagoOnline' }, canActivate: [AuthGuard] },
      { path: 'leads', loadChildren: () => import('./components/leads/leads.module').then(m => m.LeadsModule), data: { animation: 'leads', roles: 'Administrador,AdminRenault,CallCenter,CallCenter_24_7,RedRespIT,RgManagerRed,RgMarketing,RgManagerRecsa,RgTransversal,ResponsablePv,RedJefeTaller,RedAsesor,RedRespMktg,ResponsableCalidad,RedRespLead,ResponsablePvR2,RedJefeTallerR2,RedAsesorR2,RedRespMktgR2,ResponsableCalidadR2,RedRespLeadR2,RedRespITR2' }, canActivate: [AuthGuard] },
      { path: 'user-profile', loadChildren: () => import('./components/user-profile/user-profile.module').then(m => m.UserProfileModule), data: { animation: 'user-profile' }, canActivate: [AuthGuard] },
      { path: 'action-management', loadChildren: () => import('./components/action-management/action-management.module').then(m => m.ActionManagementModule), data: { animation: 'action-management', roles: 'Administrador,AdminRenault,RgManagerRed,RgMarketing,RgManagerRecsa,RgTransversal,ResponsablePv,RedJefeTaller,RedJefeAlmacen' }, canActivate: [AuthGuard] },
      { path: 'kpis', loadChildren: () => import('./components/kpis/kpis.module').then(m => m.KpisModule), data: { animation: 'kpis', roles: 'Administrador,AdminRenault,RgManagerRed,RgMarketing,RgManagerRecsa,RgTransversal,ResponsablePv,RedJefeTaller,RedJefeAlmacen,ResponsablePvR2,RedJefeTallerR2,RedJefeAlmacenR2' }, canActivate: [AuthGuard] },
      { path: 'kpis/excel', loadChildren: () => import('./components/kpis/excel/kpis-excel.module').then(m => m.KpisExcelModule), data: { animation: 'kpisExcel', roles: 'Administrador,AdminRenault,RgManagerRed,RgMarketing,RgManagerRecsa,RgTransversal' }, canActivate: [AuthGuard] },
      { path: 'admin', children: adminroutes },
      { path: 'my-zone', children: myzoneroutes },
      { path: 'renault-zone', children: renaultzoneroutes },
      { path: 'campaigns', children: campaignroutes },
      { path: 'pap', loadChildren: () => import('./components/pap-access/pap-access.module').then(m => m.PapAccessModule), data: { animation: 'pap', roles: 'Administrador,AdminRenault,RgManagerRed,RgManagerRecsa,ResponsablePv,RedJefeAlmacen,RedJefeTaller,RedRespMktg' }, canActivate: [AuthGuard] },
      { path: 'document', loadChildren: () => import('./components/document/document.module').then(m => m.DocumentModule), data: { animation: 'document' }, canActivate: [AuthGuard] },
      { path: 'myprogram', loadChildren: () => import('./components/myprogram/myprogram.module').then(m => m.MyprogramModule), data: { animation: 'myprogram', excludeRoles: 'CallCenter_24_7' }, canActivate: [AuthGuard] }
    ]
  },
  { path: '**', redirectTo: '/home' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    scrollOffset: [0, 0] // [x, y]
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
